// extracted by mini-css-extract-plugin
module.exports = {"container":"BlueTextTeaser__container","icon":"BlueTextTeaser__icon","headWithIcon":"BlueTextTeaser__headWithIcon"};